import React from "react";
import {useGetNHLPlayerSeasonStatsByPlayerIdQuery} from "../../../stores/tradefan/tradefan.api";
import "../SeasonStats.style.scss";
import Typography from "@mui/material/Typography";
import {FormattedMessage} from "react-intl";

const renderGoalieSeasonStats = (data) => {
    return <div className="seasonStats">
        <div className="statItem">
            <div>{data.GamesPlayed}</div>
            <div>GP</div>
        </div>
        <div className="statItem">
            <div>{data.Wins}-{data.Losses}-{data.OverTimeLosses}</div>
            <div>W-L-OTL</div>
        </div>
        <div className="statItem">
            <div>{data.GoalsAgainstAverage.toFixed(1)}</div>
            <div>GAA</div>
        </div>
        <div className="statItem">
            <div>{data.SavesPercentage.toFixed(1)}</div>
            <div>SV%</div>
        </div>
        <div className="statItem">
            <div>{data.ShutOuts}</div>
            <div>SO</div>
        </div>
        <div className="statItem">
            <div>{data.SVPG.toFixed(1)}</div>
            <div>SV/GM</div>
        </div>
    </div>
}
const renderPlayerSeasonStats = (data) => {
    return <div className="seasonStats">
        <div className="statItem">
            <div>{data.GamesPlayed}</div>
            <div>GP</div>
        </div>
        <div className="statItem">
            <div>{data.Goals}</div>
            <div>G</div>
        </div>
        <div className="statItem">
            <div>{data.Assists}</div>
            <div>A</div>
        </div>
        <div className="statItem">
            <div>{data.Points}</div>
            <div>PTS</div>
        </div>
        <div className="statItem">
            <div>{data.PlusMinus > 0 ? "+" : ""}{data.PlusMinus}</div>
            <div>+/-</div>
        </div>
        <div className="statItem">
            <div>{data.ShotsOnGoalPG.toFixed(1)}</div>
            <div>SOG/GM</div>

        </div>
    </div>
}

const NHLSeasonStats = ({playerId, seasonYears}) => {

    const {data} = useGetNHLPlayerSeasonStatsByPlayerIdQuery({playerId, seasonYear: seasonYears[0]});
    const isGoalie = data?.Position === "G";

    return <div className="NHLSeasonStats">
        <Typography variant="h6" className="gameLogTitle">
            {seasonYears[0]} - {seasonYears[1]} <FormattedMessage id={"popUp.contestPreview.seasonStats"}/>
        </Typography>
        {data && isGoalie && renderGoalieSeasonStats(data)}
        {data && !isGoalie && renderPlayerSeasonStats(data)}
    </div>
}



export default NHLSeasonStats;